<script>
import Layout from "../../layouts/main";
import appConfig from "@/app.config";
import {serviceOrderDetail} from '@/apis/order'
import {formatDate} from '@/apis/common'
import UserFile from "./userfile";
import PreAuditFile from "./preauditfile";
import LanguageSwitch from '../../components/language-switch';
export default {
  page: {
    title: "Verification Documents",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: { Layout,UserFile,PreAuditFile,LanguageSwitch},
  props:{
    serviceId:{
      type: String,
      required: true
    }
  },
  data() {
    return {
      serviceOrder:{
        serviceType:"",
        serviceStatus:"",
        serviceId:"",
      },
      form:{
        fileName:"",
      },      
      fileOrgName:"",
      success:false,
      error:false,
      errorMsg:"",
    };
  },
  created(){
    if(this.$route.query.serviceId!=undefined){
      this.serviceId = this.$route.query.serviceId;
    }
    this.init();
  },
  mounted() {
  },
  computed:{
    clientName(){
      return this.serviceOrder.clientName
    },
    serviceDate(){
      if(this.serviceOrder.startDate==this.serviceOrder.endDate){
        return formatDate(this.serviceOrder.startDate,"yyyy-MM-dd")
      }else{
        return formatDate(this.serviceOrder.startDate,"yyyy-MM-dd")+"-"+formatDate(this.serviceOrder.endDate,"MM-dd")
      }
    }
  },
  watch:{
  },
  methods: {
    async init(){
      await serviceOrderDetail(this.serviceId).then((res)=>{
        this.serviceOrder = res.data
      }).catch((res)=>{
        this.error = true
        if(res.message=="ERR_DATA_NONEXIST"){
          this.errorMsg = this.$t("confirm_letter.notExist")
        }else{          
          this.errorMsg = this.$t("confirm_letter.error")
        }        
      })
    }
  },
};
</script>

<template>
  <Layout>
    <div class="row  mt-4">
      <div class="col-lg-12">
        <div class="card">
          <div class="card-body" style="padding-top: 0px;">
                        <div class="row">
                          <div class="col-lg-2 col-sm-1 logo-col" >
                            <a href="http://www.greenpont.com/" class="logo">
                                <span class="logo-sm">
                                  <img src="@/assets/images/logo-sm.svg" alt height="22" />
                                </span>
                                <span class="logo-lg">
                                  <img src="@/assets/images/logo-dark.svg" alt height="36" />
                                </span>
                            </a>
                          </div>
                          <div class="col-lg-8 col-sm-10 text-center" >
                            <h5 class="card-title" style="line-height: 70px;"><span class="logo-icon">
                              <a href="http://www.greenpont.com/"><img src="@/assets/images/logo-sm.svg" alt height="22" /></a>
                              </span>{{$t("verfDocument.verfDocument")}}</h5>
                          </div>
                        </div>
                        <language-switch></language-switch>
                          <div class="card shadow-none mb-5">
                                <div class="card-header d-flex align-items-center">
                                    <div class="flex-grow-1">
                                        <h5 class="card-title">{{clientName}}</h5>
                                    </div>
                                </div>
                                <div class="card-body" v-if="error">
                                  <b-alert
                                    v-model="error"
                                    variant="danger"
                                    class="mt-3"
                                    dismissible
                                    >{{ errorMsg }}</b-alert
                                  >
                                </div>
                                <b-tabs class="mt-3" content-class="p-3" v-if="!error">
                                  <b-tab active class="border-0">
                                    <template v-slot:title>
                                      <span class="d-inline-block d-sm-none">
                                        <i class="fas fa-file-archive"></i>
                                      </span>
                                      <span class="d-none d-sm-inline-block">{{$t("verfDocument.pre")}}</span>
                                    </template>
                                    <pre-audit-file :serviceId="serviceId" :serviceStatus="serviceOrder.serviceStatus" :serviceType="serviceOrder.serviceType"></pre-audit-file>
                                  </b-tab>
                                  <b-tab>
                                    <template v-slot:title>
                                      <span class="d-inline-block d-sm-none">
                                        <i class="fas fa-file-archive"></i>
                                      </span>
                                      <span class="d-none d-sm-inline-block">{{$t("verfDocument.other")}}</span>
                                    </template>
                                    <user-file :serviceId="serviceId" :serviceStatus="serviceOrder.serviceStatus"></user-file>
                                  </b-tab>
                                </b-tabs>
                          </div>
                    </div>
        </div>
      </div>
      <!-- end col -->
    </div>
    <!-- end row -->
  </Layout>
</template>
<style lang="scss">
.is-invalid .mx-input-wrapper .mx-input{
    border: 1px solid #ec4561 !important;
  }
  .is-invalid .mx-input-wrapper .mx-icon-calendar{
    color: #ec4561 !important;
  }
</style>
